var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27,
    fill: "white",
    stroke: "#262261"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9308 24.2473C19.2887 19.9046 22.9177 16.5625 27.2751 16.5625H27.725C32.0824 16.5625 35.7113 19.9046 36.0693 24.2473C36.262 26.5854 35.5398 28.9071 34.0547 30.7233L29.0619 36.8293C28.2547 37.8165 26.7454 37.8165 25.9381 36.8293L20.9453 30.7233C19.4603 28.9071 18.738 26.5854 18.9308 24.2473ZM31.1774 23.8858C31.4825 23.5807 31.4825 23.086 31.1774 22.7809C30.8723 22.4758 30.3777 22.4758 30.0726 22.7809L26.9792 25.8743L25.4483 24.3434C25.1432 24.0383 24.6485 24.0383 24.3434 24.3434C24.0383 24.6485 24.0383 25.1432 24.3434 25.4483L26.4267 27.5316C26.7318 27.8367 27.2265 27.8367 27.5316 27.5316L31.1774 23.8858Z",
    fill: "#262261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location_pin.9b2b7dc09ce5de5f22be726a1852b23b.svg";
export { ForwardRef as ReactComponent };